import React from 'react';
import { useTable, useGlobalFilter } from 'react-table';
import { Table } from 'reactstrap';
import { GlobalFilter } from 'components/Generic/GlobalFilter';

export function TableStockClient({ columns, data, disableGlobalFilter }) {
  const cacheData = React.useMemo(() => data, [data]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data: cacheData,
    },
    useGlobalFilter
  );

  const { globalFilter } = state;

  return (
    <>
      {!disableGlobalFilter && (
        <GlobalFilter
          filter={globalFilter}
          setFilter={setGlobalFilter}
          urlNewItem={'/client/new'}
          disableButtomCreate={true}
        />
      )}
      <Table responsive hover {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  scope='col'
                  {...column.getHeaderProps()}
                  style={{ fontSize: '18px' }}
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.length > 0 ? (
            rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} style={{ fontSize: '18px' }}>
                        {cell.render('Cell')}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                colSpan='7'
                style={{ textAlign: 'center', width: '20px', fontSize: '14px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '14px',
                    alignItems: 'center',
                  }}
                >
                  Sem registro de estoque, faça uma pré-venda!
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
}
